<template>
  <ChartContainer
    :value="current"
    :type="type"
    :lastChart="lastChart"
    :nextChart="nextChart">
    <!--实际展示时显示的图表-->
    <div
      v-if="current && current.hidden === 1"
      class="dashboard-no-permissions__container">
      <i class="iconfont icon-no-permissions"></i>
      <div>暂无权限</div>
    </div>
    <component
      v-else-if="current && current.showType && current.value"
      ref="currentChart"
      :is="controlNameMap[current.showType]"
      :value="current.value"
      :showPropertiesHolder="current.showPropertiesHolder"
      :chartPropertiesHolder="current.chartPropertiesHolder"
      :current="current"
      :showDataDrillDownList="showDataDrillDownList">
    </component>
    <div
      v-else
      class="dashboard-empty__container">
      <i class="iconfont icon-nodata"></i>
      <div>{{current.errorPrompt}}</div>
    </div>
    <div
      class="loading-container"
      v-if="!current.isLoad">
      <van-loading
        type="spinner"
        size="20">
      </van-loading>
    </div>
  </ChartContainer>
</template>

<script>
  import ChartContainer from './common/container'
  import ControlStatistics, {controlNameMap} from '../control/Statistics/index'
  import {
    CHART_TYPE__FILTER_CONTROL,
    SHOW_TYPE__CLUSTER_BAR, SHOW_TYPE__FUNNEL,
    SHOW_TYPE__INDICATOR,
    SHOW_TYPE__LINE, SHOW_TYPE__MAP,
    SHOW_TYPE__PERCENT_BAR, SHOW_TYPE__PIE, SHOW_TYPE__RADAR, SHOW_TYPE__SCATTER,
    SHOW_TYPE__STACKED_BAR, SHOW_TYPE__STRIP, SHOW_TYPE__SUNBURST, SHOW_TYPE__TREE_MAP
  } from "../types";
  import {
    FORM_ITEM__ADDRESS, FORM_ITEM__CHECKBOX,
    FORM_ITEM__DATE,
    FORM_ITEM__DEPARTMENT,
    FORM_ITEM__LOCATION,
    FORM_ITEM__MEMBER
  } from "../../RyForm/types";

  // v-loading="!current.isLoad"
  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer,
      ...ControlStatistics
    },
    data() {
      return {
        current: this.value,
        controlNameMap
      }
    },
    methods: {
      resize() {
        const current = this.$refs.currentChart
        if (current && current.resize) {
          current.resize()
        }
      },

      showDataDrillDownList(opt) {
        if (!opt) {
          return
        }
        if (this.current.showPropertiesHolder.openDataDrillDown !== 'YES' && this.current.showType !== SHOW_TYPE__INDICATOR) {
          return
        }
        const fields = this.current.chartPropertiesHolder.latitudeFields
        const hasIdx = fields.some(item => item.hasOwnProperty('idx'))
        if (fields.length && !hasIdx) {
          this.$toast.fail('当前图表暂不支持数据下钻功能，请在图表设置里面重新设置维度即可')
          return
        }
        const {dataIndex, seriesIndex} = opt
        const conditionList = []
        if ([SHOW_TYPE__CLUSTER_BAR, SHOW_TYPE__STACKED_BAR, SHOW_TYPE__PERCENT_BAR, SHOW_TYPE__LINE, SHOW_TYPE__STRIP].includes(this.current.showType)) {
          this.current.value.xAxis.forEach(item => {
            const xAxis = item.data[dataIndex]
            let value = []
            let method = 'eq'
            if (item.fieldType === FORM_ITEM__DATE) {
              method = 'range'
              value = xAxis.originalValue
            } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(item.fieldType)) {
              value = xAxis.originalValue
            } else if ([FORM_ITEM__CHECKBOX].includes(item.fieldType)) {
              method = 'in'
              value.push(xAxis.originalValue)
            } else {
              value.push(xAxis.originalValue)
            }
            conditionList.push({
              type: item.fieldType,
              method,
              value,
              fieldId: item.dataId,
              fixedValue: 'fixed_value'
            })
            if (xAxis.subset && xAxis.subset.length) {
              const subXAxis = xAxis.subset[seriesIndex]
              let subValue = []
              let subMethod = 'eq'
              if (subXAxis.fieldType === FORM_ITEM__DATE) {
                subMethod = 'range'
                subValue = subXAxis.originalValue
              } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(subXAxis.fieldType)) {
                subValue = subXAxis.originalValue
              } else if ([FORM_ITEM__CHECKBOX].includes(subXAxis.fieldType)) {
                subMethod = 'in'
                subValue.push(subXAxis.originalValue)
              } else {
                subValue.push(subXAxis.originalValue)
              }
              conditionList.push({
                type: subXAxis.fieldType,
                method: subMethod,
                value: subValue,
                fieldId: subXAxis.dataId,
                fixedValue: 'fixed_value'
              })
            }

          })
        } else if ([SHOW_TYPE__PIE, SHOW_TYPE__FUNNEL].includes(this.current.showType)) {

          this.current.value.forEach(item => {
            if (item.xAxis && item.xAxis.value && item.xAxis.value.showValue === opt.data.name) {
              let value = []
              let method = 'eq'
              if (item.xAxis.fieldType === FORM_ITEM__DATE) {
                method = 'range'
                value = item.xAxis.value.originalValue
              } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(item.xAxis.fieldType)) {
                value = item.xAxis.value.originalValue
              } else if ([FORM_ITEM__CHECKBOX].includes(item.xAxis.fieldType)) {
                method = 'in'
                value.push(item.xAxis.value.originalValue)
              } else {
                value.push(item.xAxis.value.originalValue)
              }
              conditionList.push({
                type: item.xAxis.fieldType,
                method,
                value,
                fieldId: item.xAxis.dataId,
                fixedValue: 'fixed_value'
              })
            }
          })

        } else if ([SHOW_TYPE__TREE_MAP, SHOW_TYPE__SUNBURST, SHOW_TYPE__MAP].includes(this.current.showType)) {
          const item = opt.data
          let value = []
          let method = 'eq'
          if (item.fieldType === FORM_ITEM__DATE) {
            method = 'range'
            value = item.originalValue
          } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(item.fieldType)) {
            value = item.originalValue
          } else if ([FORM_ITEM__CHECKBOX].includes(item.fieldType)) {
            method = 'in'
            value.push(item.originalValue)
          } else {
            value.push(item.originalValue)
          }
          conditionList.push({
            type: item.fieldType,
            method,
            value,
            fieldId: item.dataId,
            fixedValue: 'fixed_value'
          })
        } else if (this.current.showType === SHOW_TYPE__RADAR) {

          this.current.value.xAxis.forEach(item => {
            if (item.name && item.name.showValue === opt.data.name) {
              let value = []
              let method = 'eq'
              if (item.fieldType === FORM_ITEM__DATE) {
                method = 'range'
                value = item.name.originalValue
              } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(item.fieldType)) {
                value = item.name.originalValue
              } else if ([FORM_ITEM__CHECKBOX].includes(item.fieldType)) {
                method = 'in'
                value.push(item.name.originalValue)
              } else {
                value.push(item.name.originalValue)
              }
              conditionList.push({
                type: item.fieldType,
                method,
                value,
                fieldId: item.dataId,
                fixedValue: 'fixed_value'
              })
            }
          })
        } else if (this.current.showType === SHOW_TYPE__SCATTER) {
          // 散点图
          if (opt.data.originalValueMap) {
            Object.keys(opt.data.originalValueMap).forEach(fieldId => {
              const item = opt.data.originalValueMap[fieldId]
              let value = []
              let method = 'eq'
              if (item.fieldType === FORM_ITEM__DATE) {
                method = 'range'
                value = item.originalValue
              } else if ([FORM_ITEM__ADDRESS, FORM_ITEM__LOCATION].includes(item.fieldType)) {
                value = item.originalValue
              } else if ([FORM_ITEM__CHECKBOX].includes(item.fieldType)) {
                method = 'in'
                value.push(item.originalValue)
              } else {
                value.push(item.originalValue)
              }
              conditionList.push({
                type: item.fieldType,
                method,
                value,
                fieldId,
                fixedValue: 'fixed_value'
              })
            })
          }
        } else if (this.current.showType === SHOW_TYPE__INDICATOR) {

        }

        // 合并图表自带的筛选条件
        this.current.chartPropertiesHolder.filter.conditionList.forEach(item => {
          conditionList.push(item)
        })
        // 合并筛选器里面的筛选条件
        if (this.current.tempFilter) {
          this.current.tempFilter.conditionList.forEach(item => {
            conditionList.push(item)
          })
        }

        const filter = {
          relation: "and",  //and or
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        }

        conditionList.forEach(item => {
          // 处理fieldId
          let fieldId = item.fieldId

          let condition = {
            type: item.type,
            method: item.method, // 匹配的方法
            value: item.value, // 匹配的值
            fieldId: fieldId,
            fixedValue: item.fixedValue,
          }
          // 处理value
          if (condition.value) {
            for(let i = 0; i < condition.value.length; i++){
              if(condition.value[i] === ''){
                condition.value.splice(i,1);
                i = i-1;
              }
            }
          }

          if (condition.method === 'empty' || condition.method === 'not_empty') {
            filter.conditionList.push(condition)
          } else if (condition.method !== 'empty' && condition.method !== 'not_empty' && condition.value.length) {
            filter.conditionList.push(condition)
          } else if (condition.fixedValue !== 'fixed_value') {
            filter.conditionList.push(condition)
          }
        })

        console.log('showDataDrillDownList', this.current.value)
        // if (this.$refs.dataDrillDownList) {
        //   this.$refs.dataDrillDownList.open({
        //     filter,
        //     appId: this.$store.getters.currentAppId,
        //     formId: this.current.dataSourceId
        //   })
        // }
        const param = {
          userId: this.$store.getters.userId,
          appId: this.$store.getters.currentAppId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.current.dataSourceId,
          token: this.$store.getters.token,
          filter
        }
        const toast = this.$toast.loading({
          message: '加载中...'
        })
        this.$store.dispatch('reqNodeSave', param).then(res => {
          const aEle = document.createElement('a')
          if (aEle) {
            aEle.href = `${location.origin}${this.$MINIAPP_BASE_PATH}/#/dataDrillDown?key=${res.nodeKey}`
            aEle.target = '_self'
            aEle.click()
          }
        })
          .catch(console.error)
          .finally(() => {
            toast.clear()
          })
      }
    }
  }
</script>
